import React, { useEffect, useState } from 'react'
import { Container, Row,Col, Card  } from "react-bootstrap"
import FormLogin,{action} from '../components/FormLogin'
import logo from '../assets/logo.png'
import { Link, useLocation, redirect  } from "react-router-dom";
import { is_authenticated } from '../module/auth'

export const logIn = action;

export const loader = (data) =>{

    if(is_authenticated()){
        return redirect("/");
    }
    return null;
}

function Login() {

    const [message,set_message] = useState(undefined);

    // Obtén la ubicación actual, que incluye la información de la URL
    const location = useLocation();
  

    useEffect(()=>{

         // Extrae el valor del parámetro "msg" de la query string
        const searchParams = new URLSearchParams(location.search);
        const msg = searchParams.get('msg');

        if(msg === "registerSuccess"){
            set_message({show:true,message:"Ya puedes iniciar sesión",variant:"primary"})
        }
        
    },[location]);
    
  return (
    <>
        <Container>
            <Row className='justify-content-center mt-4'>
                <Col sm='8' md='6' lg='5' xl='4'>

                <Card style={{marginTop:"50px"}}>
                    <Card.Body>
                        <Card.Title className='m-2'>
                            <h3 className='text-center'>Iniciar Sesión</h3>
                        </Card.Title>

                        <Row className='mb-4'>
                            <Col>
                            <div style={{
                                "width"                 : "150px",
                                "height"                : "150px",
                                "marginLeft"            : "auto",
                                "marginRight"           : "auto",
                                "backgroundImage"       : `url(${logo})`,
                                "backgroundPosition"    : "center",
                                "backgroundRepeat"      : "no-repeat",
                                "backgroundSize"        : "500px 150px",
                                "backgroundPositionX"   : "left"
                                }} >

                            </div>
                            </Col>
                        </Row>
                        
                        <FormLogin message={message}/>

                        <Row className='justify-content-between border-top pt-4 pb-4'>
                            <Col>
                                <Link to={'/reset-password'} style={{"display":"block"}} className='text-center'>Olvidé mi contraseña</Link>
                            </Col>
                            <Col>
                                <Link to={'/register'} style={{"display":"block"}} className='text-center'>Crear cuenta</Link>
                            </Col>
                        </Row>
                    </Card.Body>
                    </Card>

                    
                </Col>
            </Row>
        </Container>
    </>
  )
}

export default Login